import(/* webpackMode: "eager" */ "/app/apps/shop/src/components/common/Telemetry/TelemetryManager.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/shop/src/styles/global.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.5_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_eocq57jkeunibbsz7bxjvo46qq/node_modules/next/dist/client/script.js");
